import React, { useState } from 'react';

import { FormControl, List, ListItem, ListItemText, Checkbox, Button, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';

import { useTranslation } from "react-i18next";

const MultiSelectCheckbox = ({ options, handleMultiRoutes, selectedRoutes, setSelectedRoutes }) => {

  const [t] = useTranslation('common');

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: purple[500],
    '&:hover': {
      backgroundColor: purple[700],
    },
  }));

  const handleCheckAll = () => {
    if (selectedRoutes.length === options.length) {
      setSelectedRoutes([]);
    } else {
      setSelectedRoutes(options);
    }
  };

  return (
    <div className="col">
      <FormControl component="fieldset"
        style={{ width: '90%' }}>
        <List component={Paper}
          dense
          style={{ maxHeight: 300, overflowY: 'auto' }}
        >
          {options.map((option) => (
            <ListItem key={option}>
              <ListItemText primary={option} />
              <Checkbox
                checked={selectedRoutes.indexOf(option) !== -1}
                onChange={() => handleMultiRoutes(option, selectedRoutes, setSelectedRoutes)}
              />
            </ListItem>
          ))}
        </List>
        <ColorButton variant="contained" onClick={handleCheckAll}
          style={{ width: '100%' }}>
          {selectedRoutes.length === options.length ? t('datatable.uncheck') : t('datatable.check')}
        </ColorButton>
      </FormControl>
    </div>
  );
};


export default MultiSelectCheckbox;